import { render, staticRenderFns } from "./TarjetaCadenaComercios.vue?vue&type=template&id=0cbb07ce&scoped=true&lang=pug&"
import script from "./TarjetaCadenaComercios.vue?vue&type=script&lang=js&"
export * from "./TarjetaCadenaComercios.vue?vue&type=script&lang=js&"
import style0 from "./TarjetaCadenaComercios.vue?vue&type=style&index=0&id=0cbb07ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbb07ce",
  null
  
)

export default component.exports